module.exports = __webpack_public_path__ + "assets/img/1_613.9f21a484.jpg";